var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('header',[_c('Navbar',{attrs:{"title":"francisco.llanquipichun.cl"}})],1),_c('div',{staticClass:"container is-max-desktop"},[_c('router-view')],1),_c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container is-max-desktop"},[_c('content-footer')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }